<template>
  <div class="w-100 h-100 text-center">
    <h1 class="display-2">
      {{ title }}
    </h1>

    <b-container fluid>
      <b-row>
        <b-col
          md="10"
          lg="8"
          xl="6"
          class="text-left"
          offset-md="1"
          offset-lg="2"
          offset-xl="3"
        >
          <div v-if="loading" class="text-center text-dark my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Loading...</strong>
          </div>
          <div v-else>
            <b-table
              hover
              :items="items"
              :fields="fields"
              fluid
              class="bg-white mx-1 rounded"
            >
              <template v-slot:cell(errors)="data">
                <div v-if="row.item.numberErrors > 0">
                  {{ row.item.errorFile }}
                </div>
                <div v-else>
                  <b-badge variant="success">Passed</b-badge>
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from '@/utilities/handle-errors';

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import {
  // mapState
  // mapGetters,
  // mapActions
} from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  components: {},
  props: {},
  data: function() {
    return {
      title: "CSV Table",
      selectedFile: null,
      fields: [
        { key: "date", label: "Date" },
        { key: "original_file", label: "Original File" },
        { key: "errors", label: "Errors" }
      ],
      items: [
        {
          date: "9/27/19",
          original_file: "file1.csv",
          errorFile: "errorFile.csv",
          numberErrors: 3
        },
        {
          date: "9/27/19",
          original_file: "file1.csv",
          errorFile: null,
          numberErrors: 0
        },
        {
          date: "9/27/19",
          original_file: "file1.csv",
          errorFile: "errorFile.csv",
          numberErrors: 2
        }
      ],
      loading: true
    };
  },
  computed: {},
  created: function() {
    setTimeout(() => {
      this.loadingSpinner();
    }, 3000);
  },
  mounted: {},
  methods: {
    // ...mapActions('sample', ['nameOfAction']),
    get: function() {
      // HTTP.get('/').then((response) => {
      //     let something = response.data;
      // }).catch((error) => {
      //     HandleErrors.HandleErrors(error);
      // });
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {},
    onFileSelected: function(event) {
      this.selectedFile = event.target.files[0];
    },
    onUpload: function() {
      const fd = new FormData();
      fd.append("file", this.selectedFile, this.selectedFile.name);
      HTTP.post("/kenya/upload-subject-microscopy/", fd)
        .then(response => {
          response.data;
        }).catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    loadingSpinner: function() {
      this.loading = false;
    }
  }
  // beforeRouteEnter(to, from, next) {
  //     // called before the route that renders this component is confirmed.
  //     // does NOT have access to `this` component instance,
  //     // because it has not been created yet when this guard is called!
  // },
  // beforeRouteUpdate(to, from, next) {
  //     // called when the route that renders this component has changed,
  //     // but this component is reused in the new route.
  //     // For example, for a route with dynamic params `/foo/:id`, when we
  //     // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
  //     // will be reused, and this hook will be called when that happens.
  //     // has access to `this` component instance.
  // },
  // beforeRouteLeave(to, from, next) {
  //     // called when the route that renders this component is about to
  //     // be navigated away from.
  //     // has access to `this` component instance.
  // },
};
</script>
